export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";

export type AuthTokens = {
    accessToken: string;
    refreshToken: string;
};

export const getAccessToken = () => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const setAccessToken = (token: string) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

export const deleteAccessToken = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const setTokens = (tokenObject: AuthTokens) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokenObject[ACCESS_TOKEN_KEY]);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokenObject[REFRESH_TOKEN_KEY]);
};
